import { Button, Col, Row, Form } from '@themesberg/react-bootstrap'
import React from 'react'
import useTransactionBList from './../../TransactionsBanking/hooks/useTransactionBList'
import Trigger from '../../../../components/OverlayTrigger'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload, faRedoAlt } from '@fortawesome/pro-solid-svg-icons'
import { handleDownloadCSV } from '../../../../utils/fileDownloader'
import AllTransactionsList from '../../../../components/AllTransactions/AllTransactionsList'
import { allTransactionType, AMOUNT_TYPE } from '../../TransactionsBanking/constants'
import useCheckPermission from '../../../../utils/checkPermission'
import CustomDatePicker from '../../../../components/Custom/CustomDatePicker'
import { FILTER_BY } from '../../../../constants/table'

const AllTransactions = ({ isTenant = false }) => {
  const {
    page,
    over,
    state,
    limit,
    sortBy,
    loading,
    setPage,
    setOver,
    setLimit,
    setState,
    userData,
    setSearch,
    setSortBy,
    countries,
    totalPages,
    selectedAction,
    allTransactions,
    selectedCurrency,
    setSelectedAction,
    getCsvDownloadUrl,
    setSelectedClient,
    setSelectedCurrency,
    allTransactionsTotalPages,
    setSelectedPaymentProvider,
    selectedAmountType,
    setSelectedAmountType,
    filterBy,
    setFilterBy,
    updatedAtState,
    setUpdatedAtState,
    formatDateYMD,
    resetDate,
  } = useTransactionBList({ isUserDetail: true, allTransaction: true, isTenant })

  const { isHidden } = useCheckPermission()

  return (
    <>
      <Row>
        <Col xs='auto' className='d-flex mb-3'>
          <Form.Label column='sm' className='mx-auto text-nowrap px-2'>
            Transaction Type
          </Form.Label>
          <Form.Select
            size='sm'
            style={{ maxWidth: '230px' }}
            onChange={(e) => setSelectedAction(e.target.value)}
            value={selectedAction}
          >
            <option value=''>Choose Type</option>
            {allTransactionType && allTransactionType?.map(
              ({ label, value }) => (
                <option key={label} value={value}>
                  {label}
                </option>
              )
            )}
          </Form.Select>
        </Col>

        <Col xs='auto' className='d-flex mb-3'>
          <Form.Label column='sm' className='mx-auto text-nowrap px-2'>
            Amount Type
          </Form.Label>
          <Form.Select
            size='sm'
            style={{ maxWidth: '230px' }}
            onChange={(e) => setSelectedAmountType(e.target.value)}
            value={selectedAmountType}
          >
            {AMOUNT_TYPE && AMOUNT_TYPE?.map(
              ({ label, value }) => (
                <option key={label} value={value}>
                  {label}
                </option>
              )
            )}
          </Form.Select>
        </Col>

        <Col xs='auto' className='d-flex mb-3'>
          <Form.Label column='sm' className='mx-auto text-nowrap px-2'>
            Created At/Time Period
          </Form.Label>
          <Form.Check
            name='check2'
            className='px-2'
            value={FILTER_BY.CREATED_AT}
            checked={filterBy === FILTER_BY.CREATED_AT}
            onChange={(e) => setFilterBy(e.target.value)}
          />
          <CustomDatePicker onDateChange={setState} date={state} dateFormatter={formatDateYMD} />
        </Col>

        <Col xs='auto' className='d-flex mb-3'>
          <Form.Label column='sm' className='mx-auto text-nowrap px-2'>
            Updated At/Time Period
          </Form.Label>
          <Form.Check
            name='check2'
            className='px-2'
            value={FILTER_BY.UPDATED_AT}
            checked={filterBy === FILTER_BY.UPDATED_AT}
            onChange={(e) => setFilterBy(e.target.value)}
          />
          <CustomDatePicker onDateChange={setUpdatedAtState} date={updatedAtState} dateFormatter={formatDateYMD} />
        </Col>
        <Col xs='auto' className='d-flex mb-3'>
          <Trigger message='Reset Filters'>
            <Button
              variant='outline-success'
              className=''
              size='sm'
              onClick={() => {
                setSearch('')
                setSelectedAction('')
                setSelectedAmountType('0')
                setSelectedCurrency('')
                setLimit(15)
                setPage(1)
                setSelectedPaymentProvider('')
                setSelectedClient('')
                resetDate()
              }}
            >
              <FontAwesomeIcon icon={faRedoAlt} />
            </Button>
          </Trigger>
          <Trigger message='Download as CSV'>
            <Button
              variant='outline-success'
              size='sm'
              style={{ marginLeft: '10px' }}
              hidden={isHidden({ module: { key: 'Users', value: 'DT' } })}
              disabled={allTransactions?.count === 0}
              onClick={() => { handleDownloadCSV(getCsvDownloadUrl('allTransactions'), `All_Transactions_${userData?.email}`) }}
            >
              <FontAwesomeIcon icon={faFileDownload} />
            </Button>
          </Trigger>
        </Col>

      </Row>
      {/* new and same list is needed ! */}
      <AllTransactionsList
        loading={loading}
        page={page}
        setLimit={setLimit}
        limit={limit}
        setPage={setPage}
        totalPages={totalPages}
        transactions={allTransactions}
        isTenant={isTenant}
        selectedCurrency={selectedCurrency}
        selectedAction={selectedAction}
        selectedAmountType={selectedAmountType}
        userDetail
        countries={countries}
        allTransactionsTotalPages={allTransactionsTotalPages}
        sortBy={sortBy}
        setSortBy={setSortBy}
        over={over}
        setOver={setOver}
      />
    </>
  )
}

export default React.memo(AllTransactions)
